import { ajax } from '../index'

/**
 * contact-us 相关接口
 */
export default {
  // 获取联系我们页面 表单配置
  getContactUsSetting() {
    return ajax.get('api', `/api/v1/contact-us/setting`, {})
  },

  // 提交联系我们页面 表单数据
  submitContactUsData(dataObj: any) {
    return ajax.post('api', `/api/v1/contact-us/send`, dataObj)
  },

  // 获取联系我们页面是否高亮livechat客服
  getContactUsChat() {
    return ajax.get('api', `/api/v1/contact-us/chat`, {})
  },
}